export default function redirectToService(type, id, flag) {
  console.log('redirectToService', type,id,flag);
  //flag 1:物业服务/2:商务服务/3:政务平台/4:金融服务/5:人力资源/6:园区配套/7:产品路演/8:信息交互
  // 3：自定义服务 4：找工作 5：服务外包 6：培训 7：产品路演 8：求购 9：美食街 10：入驻 11：优选服务 12：会议室 13：活动 14：福利 16：自定义设施出租 18：物业报修
  let typePath = {
    4 : '/humanResource/jobList', // 找工作
    5 : '/humanResource/serviceList', // 服务外包
    6 : '/humanResource/eduList', // 培训
    7 : '/production', // 产品路演=营销服务
    8 : '/bbs/needBuyList', // 求购
    9 : '/parkCompleteSet/foodCourt', // 美食街
    10 : '/propertyDetiles/'+id, // 入驻
    11 : '/business/businessList/recommend/'+id, // 优选服务
    12 : '/business/businessList/meetingRoom/'+id, // 会议室
    13 : '/parkCompleteSet/campusActivities', // 活动
    14 : '/parkCompleteSet/exclusiveActivities', // 福利
    16 : '/business/businessList/equipment/'+id, // 自定义设施出租
    18 : '/propertyDetiles/'+id, // 物业报修
  };
  // 自定义服务
  let flagPath = {
    1: '/propertyDetiles/' + id,// 物业服务
    3: '/governmentDetiles/' + id,// 政务平台
    4: '/financeDetalis/' + id,// 金融服务
  }

  let path = type==3 ? flagPath[flag] : typePath[type];
  console.log('redirectPath',path);
  return path;
}




// WEBPACK FOOTER //
// ./src/utils/redirectTo.js